import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxIconButtonModule } from '@wdx/shared/components/wdx-icon-button';

@Component({
    selector: 'wdx-copy-to-clipboard',
    templateUrl: './wdx-copy-to-clipboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WdxIconButtonModule, WdxIconModule],
})
export class WdxCopyToClipboardComponent {
    @Input() copyValue?: string;
    @Input() cySelector?: string;

    @Output() copyClipboardSuccess: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    onClick(): void {
        if (!this.copyValue) {
            return;
        }
        navigator.clipboard
            .writeText(this.copyValue)
            .then(() => this.copyClipboardSuccess.emit(true))
            .catch((error) => {
                console.error('Failed to copy to clipboard', error);
                this.copyClipboardSuccess.emit(false);
            });
    }
}
